'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by Administrator on 2016/6/28.
                                   * 暂时无用
                                   */

// import Dropzone from 'react-dropzone';
// import superagent from 'superagent';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _GoeasyInputField = require('../GoeasyInputField/GoeasyInputField');

var _GoeasyInputField2 = _interopRequireDefault(_GoeasyInputField);

var _reduxForm = require('redux-form');

var _AddressChosenComponentTwoLevel = require('../AddressChosenComponent/AddressChosenComponentTwoLevel');

var _AddressChosenComponentTwoLevel2 = _interopRequireDefault(_AddressChosenComponentTwoLevel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExperienceShopRegisterForm = (_dec = (0, _reduxForm.reduxForm)({
  form: 'experienceShopRegisterForm',
  fields: ['experienceTheme', 'addressId', 'addressDetail', 'latLng', 'shopPicture']
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ExperienceShopRegisterForm, _Component);

  function ExperienceShopRegisterForm() {
    (0, _classCallCheck3.default)(this, ExperienceShopRegisterForm);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ExperienceShopRegisterForm).call(this));
  }

  /*
   onDrop(files) {
   console.log(files);
   const {
   fields: {
   shopPicture
   }
   } = this.props;
    const req = superagent.post('/file');
   files.forEach((file)=> {
   req.attach('photos', file);
   });
   req.end((data)=> {
   console.log(shopPicture);
   console.log(data);
   });
   }
    addressChange(value, level) {
   const {onAddressChange} = this.props;
   if (onAddressChange) {
   onAddressChange(value, level);
   }
   }*/

  (0, _createClass3.default)(ExperienceShopRegisterForm, [{
    key: 'render',
    value: function render() {
      var styles = require('./ExperienceShopRegisterForm.scss');
      var _props = this.props;
      var _props$fields = _props.fields;
      var experienceTheme = _props$fields.experienceTheme;
      var addressId = _props$fields.addressId;
      var addressDetail = _props$fields.addressDetail;
      var handleSubmit = _props.handleSubmit;
      var addressData = _props.addressData;
      var labelStyle = _props.labelStyle;

      var inputLabelStyle = {};
      if (labelStyle) {
        inputLabelStyle = (0, _extends3.default)({}, labelStyle);
      }

      return _react2.default.createElement(
        'form',
        { onSubmit: handleSubmit, encType: 'multipart/form-data' },
        _react2.default.createElement(
          'div',
          { className: styles.component },
          _react2.default.createElement(_GoeasyInputField2.default, { labelStyle: inputLabelStyle, label: '主题：', inputPlaceholder: '',
            formProps: experienceTheme }),
          _react2.default.createElement(_AddressChosenComponentTwoLevel2.default, { formProps: addressId, onAddressChange: this.addressChange.bind(this),
            data: addressData }),
          _react2.default.createElement(_GoeasyInputField2.default, { labelStyle: inputLabelStyle, label: '地址详情：', inputPlaceholder: '',
            formProps: addressDetail }),
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement('input', { className: styles.btn, type: 'button', onClick: handleSubmit, value: '确定' })
        )
      );
    }
  }]);
  return ExperienceShopRegisterForm;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired,
  handleSubmit: _react.PropTypes.func,
  labelStyle: _react.PropTypes.object,
  addressData: _react.PropTypes.object,
  onAddressChange: _react.PropTypes.func
}, _temp)) || _class);
exports.default = ExperienceShopRegisterForm;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ExperienceShopRegisterForm/ExperienceShopRegisterForm.js
 ** module id = 1333
 ** module chunks = 0
 **/